import Loading from "../../results/loading";
import Random from "../../results/random";
import React from "react";
import { byCodes, getPostNum } from "../../../constant/General";
import ContentWrapper from "./ContentWrapper";


const ResultMTDay = ({ result, config }) => {
    const { results, rightResults } = result;
    let posts = byCodes(rightResults, ["F", "A", "B", "C", "D"]);

    return <ContentWrapper>
        <div className="d-flex overflow-hidden justify-content-end w-50">
            <table style={{ height: "766px" }}>
                <tbody>
                    {results.map((res, j) => {
                        const hlBG = config.hlIndex.includes(j);
                        const style = {
                            background: hlBG ? config.hlBG : config.background
                        }
                        return <tr style={style} className={`row-${j}`} key={j}>
                            {res.items.map((list, i) => {
                                const style = config.row[`row_${j}`]
                                return <td align="middle" key={`${j}_${i}`}>
                                    {list.map((num, index) => {
                                        if (num.includes("*")) {
                                            return <div key={index}>
                                                <Loading style={style?.loading ?? config?.loading}
                                                    className="loading-res"
                                                    sizeDigit={num.length} />
                                            </div>
                                        }
                                        if (num.includes("?")) {
                                            let randomSt = style?.random ? {
                                                ...config.random,
                                                ...style.random,
                                            } : config.random
                                            return <div key={index}>
                                                <Random className="random-res" style={randomSt} sizeDigit={num.length} />
                                            </div>
                                        }
                                        return <div style={{ ...style?.normal }}
                                            key={index}>{num}</div>
                                    })}
                                </td>
                            })}
                        </tr>
                    })}
                </tbody>
            </table>
        </div>

        <div style={{
            backgroundImage: `url(${require(`../../../assets/images/live-v2/${config.type}/day/bg.png`)})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%"
        }} className="w-50 overflow-hidden d-flex justify-content-center align-items-center">
            <div className="position-relative">
                <img height="700" className="w-100"
                    src={require(`../../../assets/images/live-v2/${config.type}/day/post.png`)}
                    alt="__" />

                <div style={{
                    top: "10px", left: "235px",
                    fontSize: "110px"
                }} className="position-absolute post">
                    {posts.map((post, i) => {
                        return <div
                            style={{
                                height: "110px", marginBottom: "30px"
                            }}
                            className="d-flex" key={i}>
                            <div className="d-flex justify-content-center" style={{
                                marginRight: "31px", width: "180px"
                            }}>{getPostNum(post.twoD)}</div>
                            <div className="d-flex justify-content-center" style={{
                                width: "261px"
                            }}>{getPostNum(post.threeD)}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </ContentWrapper>
}

export default ResultMTDay;